import "../components/AddCategory/AddCategory.scss";
import AddCategory from "../components/AddCategory/AddCategory";
import CatList from "../components/AddCategory/CatList";
import { useEffect, useState } from "react";
import sendRequest from "../hooks/useAxios";

import i1 from "../assets/images/test/1.png";
import i2 from "../assets/images/test/2.png";
import i3 from "../assets/images/test/3.jpg";
export default function CatPage() {
  const [catListData, setCatListData] = useState([
    // {
    //   cat: { name: "دسته بندی اول" },
    //   product: [
    //     { src: i1 },
    //     { src: i2 },
    //     { src: i3 },
    //     { src: i1 },
    //     { src: i2 },
    //     { src: i3 },
    //     { src: i1 },
    //     { src: i2 },
    //     { src: i3 },
    //     { src: i1 },
    //     { src: i2 },
    //     { src: i3 },
    //     { src: i1 },
    //     { src: i2 },
    //     { src: i3 },
    //     { src: i1 },
    //     { src: i2 },
    //     { src: i3 },
    //   ],
    // },
    // {
    //   cat: { name: "دسته بندی دوم" },
    //   product: [{ src: i1 }, { src: i1 }, { src: i2 }, { src: i3 }],
    // },
    // {
    //   cat: { name: "دسته بندی سوم" },
    //   product: [{ src: i1 }],
    // },
  ]);
  useEffect(() => {
    sendRequest("?action=get_product_with_sub_product").then((data) => {
      setCatListData(data.data.result);
    });
  }, []);
  return (
    <div>
      <div className="cat-list shadow p-3 mx-auto mt-5  position-relative">
        <div className="text-center py-1 fw-bold fs-5 position-absolute  title px-3">
          دسته بندی و محصولات
        </div>
        <AddCategory />
        <hr className="my-4" />
        <CatList catListData={catListData} />
      </div>
    </div>
  );
}
